export class ReportsLabelEN {

    home: {
        pre: string;
        users: string;
        status: string;
        workload: string;
    }

    preApproval: {
        title: string;
        pieTitle: string;
        from: string;
        to: string;
        timeFrame: string;
        period: string;
        noData: string;
        yesterday: string;
        lastSeven: string;
        lastThirty: string;
        or: string;
        list: string;
    }

    approvalList: {
        title: string;
        applicantNumber: string;
        applicantName: string;
        type: string;
        asset: string;
        status: string;
    }

    button: {
        list: string;
        goBack: string;
    }

    constructor() {

        this.home = {
            pre: "Pre-Approval Status",
            status: "Shows the average of pre-Approved quotations",
            users: "Show the load of user's workload in average",
            workload: "Users Workload"
        }

        this.preApproval = {
            title: "Application Pre-Approval Status",
            pieTitle: "Pre-Approval Status",
            from: "From",
            to: "To",
            timeFrame: "Select the time frame",
            period: "Select the period of time",
            noData: "No Data Available",
            yesterday: "Yesterday",
            lastSeven: "Last 7 days",
            lastThirty: "Last 30 days",
            list: "List",
            or: "Or"
        }

        this.approvalList = {
            title: "Application In a Period",
            applicantNumber: "Application Number",
            applicantName: "Applicant Name",
            type: "Employment Type",
            asset: "Asset",
            status: "Pre-Approval Status"
        }

        this.button = {
            list: "List",
            goBack: "Go Back"
        }
    }
}